import React, { useState } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import Button from '@dashboard/components/Button';
import { FormErrorBase } from '@dashboard/components/Formik/components/FormError';
import Spinner from '@dashboard/components/Spinner';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';

export default function SendTestEmailButton({ onSend }) {
  const { user } = useAuth();
  const [testEmailState, setTestEmailState] = useState('initial'); // initial, sending, sent, error

  async function handleSendTestEmail() {
    setTestEmailState('sending');
    const sent = await onSend();

    if (!sent) {
      setTestEmailState('error');
      return;
    }

    setTestEmailState('sent');
    window.setTimeout(() => {
      setTestEmailState('initial');
    }, 2000);
  }

  return (
    <div className="flex gap-x-2 ml-auto items-start">
      <div className="flex flex-col">
        <Button
          type="button"
          className="ml-auto"
          onClick={handleSendTestEmail}
          appearance="light"
          disabled={testEmailState === 'sending' || testEmailState === 'sent'}
        >
          {(testEmailState === 'initial' || testEmailState === 'error') && 'Send test email'}

          {testEmailState === 'sending' && (
            <>
              Sending test email <Spinner className="ml-2 h-5 w-5" />
            </>
          )}

          {testEmailState === 'sent' && (
            <>
              Email sent <CheckCircleIcon className="ml-2 h-5 w-5" />
            </>
          )}
        </Button>

        <div className="text-right text-gray-800 dark:text-foreground mt-1 truncate w-64">
          {testEmailState === 'error' && (
            <FormErrorBase>Failed to send email. Please try again.</FormErrorBase>
          )}

          <small className="text-[0.8rem]">
            Sending to <strong>{user.email}</strong>
          </small>
        </div>
      </div>
    </div>
  );
}
